export default __webpack_public_path__ + "static/media/365 steak badge.b9130a07.svg";